<template>
    <InertiaLink class="inline-flex items-center p-1.5 border border-transparent rounded-full shadow-sm text-secondary bg-primary hover:bg-primary-hover focus:outline-none">
        <PlusIcon class="h-5 w-5" />
    </InertiaLink>
</template>

<script>
import { PlusIcon } from '@heroicons/vue/outline'

export default {
    components: {
        PlusIcon,
    },
}
</script>
